// extracted by mini-css-extract-plugin
export default {"tableheader":"ccf-contact-history-table-header_tableheader__64qrO","label":"ccf-contact-history-table-header_label__Viofr"};